export const USE_DOWNLOAD_DETECTIONS_HANDLER_KEY = 'useExportDetections';
